import React, {useContext, useState, useEffect, Fragment} from "react";
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { motion } from 'framer-motion';
import { menuLi } from "../functions/motions";
import '../scss/style.css';
import '../scss/navigation.css';
import axios from "axios";
import { AuthContext } from '../Context/AuthProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket, faKey, faPeopleRoof, faLandmark, faBullhorn, faCheckToSlot, faLandMineOn, faDroplet, faTemperatureHigh } from '@fortawesome/free-solid-svg-icons'
import { czyAktywnySerwis } from "../functions/utilities.js";
import { Tooltip } from "@mui/material";

import { 
    fetchMieszkancy, 
    fetchUsers,
    fetchSerwis
  } from '../Redux/Actions.js'; 

const Navigation = () => {
    const navigate = useNavigate();
    const { auth, role } = useContext(AuthContext);

    const dispatch = useDispatch();

    
    const [czyAktywny, setCzyAktywny] = useState(false);

    useEffect( ()=> {
        dispatch(fetchMieszkancy()); 
        dispatch(fetchUsers());
        dispatch(fetchSerwis());
    },[dispatch]);
      
    const serwisy = useSelector( state => state?.serwis?.data);

    useEffect( () => {
        const odp = czyAktywnySerwis(serwisy);
        setCzyAktywny( odp );
    },[serwisy]);
      
    const logout = () => {
        axios.get("/api/logout")
            .then( res => {
                if (res.data.Status === "Success") {
                    // navigate('/');
                    window.location.reload(false);
                } else {
                    alert("error");
                }
            }).catch(err => console.log(err));
    }
    

    const clickLogo = () => navigate(`/`);

    return(
        <motion.nav
            initial={{ y: -200 }}
            animate={{ y: 0 }}
            transition={{ duration: .5 }}
        >
            <div className="main">
                <div className="logo pointer" onClick={clickLogo}>
                    {/* <img src={logo}  alt="logo"></img> */}
                </div>
                <div className="menu">
                    <ul>
                        <motion.li 
                            whileHover={menuLi}
                        >
                            <Link to="https://bonadministrator.pl" target={"_blank"} > {"Strona główna"} </Link> 
                        </motion.li>
                        <motion.li
                            whileHover={menuLi}
                        >
                            <Link to="https://bonadministrator.pl/o-nas" target={"_blank"}> {"O Nas"} </Link> 
                        </motion.li>
                        <motion.li
                            whileHover={menuLi}
                        >
                            <Link to="https://bonadministrator.pl/oferta" target={"_blank"}> {"Oferta"} </Link> 
                        </motion.li>
                        <motion.li 
                            whileHover={menuLi}
                        >
                            <Link to="https://bonadministrator.pl/kontakt" target={"_blank"} > {"Kontakt"} </Link> 
                        </motion.li>
                        <motion.li 
                            whileHover={menuLi}
                        >
                            <Link to="https://bonadministrator.pl/ogloszenia" target={"_blank"}> {"Ogłoszenia"} </Link> 
                        </motion.li>
                        <motion.li 
                            whileHover={menuLi}
                        >
                            <Link to="/komunikaty"> {"Komunikaty"} </Link> 
                        </motion.li>
                        {role === "mieszkaniec" && !czyAktywny? (
                            <motion.li 
                                whileHover={menuLi}
                            >
                                <NavLink to="/mieszkaniec"> {"Moje dane"}  </NavLink> 

                            </motion.li> ) : ""
                        }
                        {role === "admin" ? (
                            <Fragment>                        
                                <motion.li 
                                    whileHover={menuLi}
                                    style={{marginLeft: "50px"}}
                                >
                                    <NavLink to="/wspolnoty">
                                        <Tooltip
                                            title="Lista wspólnot"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faPeopleRoof} 
                                                className="pointer"
                                                style={{padding: '5px 10px'}}
                                            />  
                                        </Tooltip>
                                    </NavLink> 
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    <NavLink to="/woda"> 
                                        <Tooltip
                                            title="Rozliczanie wody"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faDroplet} 
                                                className="pointer"
                                                style={{padding: '5px 10px'}}
                                            />   
                                        </Tooltip>
                                    </NavLink> 
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    {/* <NavLink to="/co">  */}
                                        <Tooltip
                                            title="Centralne ogrzewanie"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faTemperatureHigh} 
                                                className="pointer"
                                                style={{padding: '5px 10px', cursor: 'not-allowed'}}
                                            />   
                                        </Tooltip>
                                    {/* </NavLink>  */}
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    <NavLink to="/ksiegowosc"> 
                                        <Tooltip
                                            title="Księgowość"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faLandmark} 
                                                className="pointer"
                                                style={{padding: '5px 10px'}}
                                            />   
                                        </Tooltip>
                                    </NavLink> 
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    <NavLink to="/usterki">     
                                        <Tooltip
                                            title="Usterki"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faBullhorn} 
                                                className="pointer"
                                                style={{padding: '5px 10px'}}
                                            />   
                                        </Tooltip>                                
                                    </NavLink> 
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    <NavLink to="/glosowanie">           
                                        <Tooltip
                                            title="Głosowanie"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faCheckToSlot} 
                                                className="pointer"
                                                style={{padding: '5px 10px'}}
                                            /> 
                                        </Tooltip>                          
                                    </NavLink> 
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    <NavLink to="/tablica">        
                                        <Tooltip
                                            title="Tablica serwisowa"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faLandMineOn} 
                                                className="pointer "
                                                style={{padding: '5px 10px'}}
                                            /> 
                                        </Tooltip>                               
                                    </NavLink> 
                                </motion.li>
                                <motion.li 
                                    whileHover={menuLi}
                                >
                                    <NavLink to="/logi">      
                                        <Tooltip
                                            title="Odwiedziny"
                                            placement="top"
                                        >
                                            <FontAwesomeIcon 
                                                icon={faKey} 
                                                className="pointer"
                                                style={{padding: '5px 10px'}}
                                            />   
                                        </Tooltip>                               
                                    </NavLink> 
                                </motion.li> 
                                {/* <motion.li>
                                    <FontAwesomeIcon 
                                        icon={faMagnifyingGlass} 
                                        onClick={handleLens}
                                        className="pointer"
                                        style={{padding: '5px 10px'}}
                                    />  
                                </motion.li> */}



                            </Fragment>
                        ) : "" }
                        { auth == false || role==undefined? (
                            <motion.li 
                                whileHover={menuLi}
                            >
                                <Tooltip
                                    title="Zaloguj"
                                    placement="top"
                                >
                                    <NavLink to="/login" > {"Logowanie"} </NavLink>
                                </Tooltip> 
                            </motion.li>
                        ): 
                            ""
                        }                        
                    </ul>
                    <div>
                    </div>

                    { auth && role!=undefined? (
                        <button onClick={logout}>
                            <Tooltip
                                title="Wyloguj"
                                placement="top"
                            >
                                <FontAwesomeIcon icon={faRightFromBracket} /> 
                            </Tooltip> 
                        </button>
                    ) : <div></div> }
                </div>
            </div>
        </motion.nav>   
    )
}

export default Navigation;